module.exports = __webpack_public_path__ + "img/icon-make-backup.02dc5d94.svg";